import React from 'react';
import { object } from 'prop-types';

const getWithReducerHOC = (key, reducer) => (WrappedComponent) => {
  class ComponentWithReducer extends React.PureComponent {
    static contextTypes = {
      store: object,
    };

    constructor(props, context) {
      super(props);
      context.store.injectReducer(key, reducer);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return ComponentWithReducer;
};

export default getWithReducerHOC;
